import React from "react";
import PropTypes from "prop-types";

import {
  FormCheckbox,
  FormDate,
  FormDateTime,
  FormDropdown,
  FormMultiselectDropdown,
  FormNumber,
  FormShortText,
  FormText,
} from "..";

export function DynamicField({ field, showDefaultValue }) {
  const fieldProps = {
    ...field,
    value: showDefaultValue ? field.value ?? field.defaultValue : field.value,
  };

  switch (field?.type?.id) {
    case "CHECKBOX":
      return <FormCheckbox {...fieldProps} />;
    case "DATE":
      return <FormDate {...fieldProps} />;
    case "DATETIME":
      return <FormDateTime {...fieldProps} />;
    case "DROPDOWN":
      return <FormDropdown {...fieldProps} />;
    case "MULTISELECT_DROPDOWN":
      return <FormMultiselectDropdown {...fieldProps} />;
    case "NUMBER":
      return <FormNumber {...fieldProps} />;
    case "SHORT_TEXT":
      return <FormShortText {...fieldProps} />;
    case "TEXT":
      return <FormText {...fieldProps} />;
    default:
      return null;
  }
}

DynamicField.propTypes = {
  field: PropTypes.object.isRequired,
  showDefaultValue: PropTypes.bool,
};

DynamicField.defaultProps = {
  showDefaultValue: true,
};

export default DynamicField;
